import React from 'react';
import PropTypes from 'prop-types';
import { Triangle } from "../../utils";
import { CardTag, CardArrow, CardHeading, CardDescription } from "./styles";

const WaysGoldCard = ({ heading, description }) => (
  <CardTag>
    <CardArrow>
      <Triangle color="white" width={12} height={12} />
    </CardArrow>
    <CardHeading>{heading}</CardHeading>
    <CardDescription>{description}</CardDescription>
  </CardTag>
);

WaysGoldCard.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default WaysGoldCard;
